import { render, staticRenderFns } from "./Dashboard-Deliveries.vue?vue&type=template&id=8648eef2"
import script from "./Dashboard-Deliveries.vue?vue&type=script&lang=js"
export * from "./Dashboard-Deliveries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports